import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import { Field, FormikProvider, useFormik } from 'formik'
import CustomInput from '../../../components/common/CustomInput'
import * as Yup from 'yup'

const validationSchema = Yup.object({
  name: Yup.string().trim().required('Name is required'),
})

function Edit() {
  const navigate = useNavigate()
  const { id } = useParams()
  const [loading, setLoading] = useState(true)
  const [submitted, setSubmitted] = useState(false)

  const formik = useFormik({
    onSubmit: (values, formikHelpers) => handleSubmit(values, formikHelpers),
    validationSchema,
    initialValues: {
      name: '',
    },
  })

  const fetchData = async () => {
    try {
      const response = await axiosAuthInstance.get(`role/detail/${id}`)
      formik.setValues({
        name: response.data.result.name,
      })
      setLoading(false)
    } catch (error) {
      console.log('error in fetching edit data: ', error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [id])

  const handleSubmit = async (values, { resetForm, setSubmitting }) => {
    if(submitted) return
    setSubmitted(true)
    try {
      const response = await axiosAuthInstance.put(`role/update/${id}`, {
        name: values.name,
      })
      if (response) {
        navigate('/roles')
      }
    } catch (error) {
      console.log(error)
    } finally{
      setSubmitting(false)
    }
  }

  if (loading) {
    return <div>Loading...</div>
  }

  return (
    <FormikProvider value={formik}>
      <form
        className='flex flex-col p-4 gap-4'
        onSubmit={(e) => {
          e.preventDefault()
          formik.handleSubmit()
        }}
      >
        <Field
          name='name'
          label='Name'
          placeholder='Enter Name'
          required
          component={CustomInput}
        />

        <button
          type='submit'
          disabled={submitted || formik.isSubmitting}
          className='bg-primary text-xl font-medium text-white rounded-lg px-6 py-2'
        >
          {formik.isSubmitting ? (
            <div className='w-5 h-5 mx-auto border-2 border-white border-solid rounded-full loader animate-spin border-t-transparent'></div>
          ) : 
          ('Update')
          }
        </button>
      </form>
    </FormikProvider>
  )
}

export default Edit
